<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<div class="grid">
   <div class="col-8">
       <app-brand-admin-header></app-brand-admin-header>
   </div>
   <div class="col-1">
        <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
            class="p-button-raised p-button-rounded"  [disabled]="isDetailsShown" *ngIf="isBrandSelectionButtonShown">
        </button>
    </div>  
</div> 

<!--  C R I T E R I A  F O R  D A T E  I N T E R V A L -->

<div class="criteria-row">

    <div class="criteria-item">
        <label for="dateFrom">Date From:</label>
        <p-datepicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" dataType="string"
            [showIcon]="true">
        </p-datepicker>
    </div>

    <div class="criteria-item">
        <label for="dateTo">Date To:</label>
        <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo" dateFormat="yy-mm-dd" dataType="string"
            [showIcon]="true">
        </p-datePicker>
    </div>

    <div class="criteria-item">
        <p-button label="Refresh" styleClass="p-button-success wal-success p-button-raised p-button-rounded"
            (click)="onSearchClick($event)">
        </p-button>
    </div>

    <div id="idSpinner" [hidden]="isSpinnerHidden">
        <div class="loader"></div>
    </div>

</div>  


<div class="dashboard" [class.details-open]="isDetailsOpen">

  <section class="tiles-panel" aria-label="Statistics overview">
    <div class="tiles-grid" [class.vertical]="isDetailsOpen" role="list">
      @for (t of tiles; track trackByKey($index, t); let i = $index) {
        <p-card
          class="wal-tile"
          role="listitem"
          [class.selected]="i === selectedIndex"
          (click)="selectTile(i)"
          tabindex="0"
          (keydown.enter)="selectTile(i)"
          (keydown.space)="selectTile(i)"
          aria-pressed="{{i === selectedIndex}}"
          [attr.aria-label]="t.title + ' tile'"
        >
          <div class="wal-tile-header">
            <h3 class="wal-tile-title"><mat-icon>{{t.icon}}</mat-icon> {{ t.title }}</h3>

            @if (t.delta !== undefined) {
              <span class="wal-tile-delta" [class.negative]="t.delta! < 0">
                <mat-icon aria-hidden="true">
                  {{ t.delta! >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
                {{ t.delta | number:'1.0-1' }}%
              </span>
            }
          </div>

          <div class="wal-tile-value">{{ t.value }}</div>

          @if (t.subtitle) {
            <div class="wal-tile-subtitle">{{ t.subtitle }}</div>
          }

        </p-card>
      }
    </div>
  </section>

  @if (isDetailsOpen && !(selectedIndex == 0 || selectedIndex == 3 || selectedIndex == 4 || selectedIndex == 5)) {
    <aside class="details-panel">
      <div class="details-header">
        <h3 class="details-title">
          {{ tiles[selectedIndex!]?.title }} — Details (UNDER CONSTRUCTION / FAKE DATA)
        </h3>
        <button pButton aria-label="Close details" (click)="closeDetails()">
          <mat-icon>close </mat-icon>
        </button>
      </div>

      <div class="details-body">
        <p class="details-description">
          {{ tiles[selectedIndex!]?.description || 'No description available.' }}
        </p>

        <p-divider></p-divider>

        <ul class="details-stats">

            <li><strong>Value:</strong> {{ tiles[selectedIndex!]?.value }}</li>

            @if (tiles[selectedIndex!]?.delta !== undefined) {
              <li><strong>Δ Change:</strong> {{ tiles[selectedIndex!]?.delta }}%</li>
            }

            @if (tiles[selectedIndex!]?.subtitle) {
              <li><strong>Period:</strong> {{ tiles[selectedIndex!]?.subtitle }}</li>
            }

        </ul>

        <div class="details-actions">

          <!-- <button pButton color="primary" (click)="closeDetails()">
            Collapse panel
          </button> -->


        </div>
      </div>
    </aside>
  }


  @if (isDetailsOpen && (selectedIndex == 0 || selectedIndex == 3 || selectedIndex == 4 || selectedIndex == 5)) {
    <aside class="details-panel">
      <div class="details-header">
<!-- 
        <h3 class="details-title">
          {{ tiles[selectedIndex!]?.title }} — Details
        </h3>
 -->
      </div>

      <div class="details-body">

        <!-- <p-divider></p-divider> -->

        <ul class="details-stats">

            <div class="panel-body">

              <div class="grid">

                  <div class="col-11">
                    <ng-template #clientStatsAnchor></ng-template>
                  </div>  

                  <div class="col-1 button-container">
                    <!-- Close Button -->
                    <button pButton aria-label="Close details"
                            (click)="closeDetails()"
                            class="btn btn-primary d-flex justify-content-center align-items-center w-100">
                      <mat-icon>close</mat-icon>
                    </button>

                    <!-- Summary Button -->
                    <p-button [disabled] = "subcomponetMode === 'Summary'"
                      label="Summary"
                      styleClass="w-100 d-flex justify-content-center p-button-success wal-success p-button-raised p-button-rounded"
                      (click)="onSetSubcomponetMode('Summary')">
                    </p-button>

                    <!-- Details Button -->
                    <p-button [disabled] = "subcomponetMode === 'Details'"
                      label="Details"
                      styleClass="w-100 d-flex justify-content-center p-button-success wal-success p-button-raised p-button-rounded"
                      (click)="onSetSubcomponetMode('Details')">
                    </p-button>

                    @if (subcomponetMode === 'Summary') {
                      <div class="field grid">
                          <label for="chartType" 
                            class="col-fixed label" 
                            style="width: 8em; margin-top: 2rem;">
                              Chart Type: 
                          </label>
                          <div class="col-12">
                          <p-select 
                              id="chartType" 
                              [options]="chartTypes" 
                              [(ngModel)]="selectedChartType"
                              (ngModelChange)="onChartTypeChanged($event)"
                              class="margin-left" 
                              [style]="{'width':'100%'}" 
                              [editable]="false">
                          </p-select>
                          </div>
                      </div>
                    }

                  </div>

              </div>

            </div>

        </ul>



        <div class="details-actions">

          <!-- <button pButton color="primary" (click)="closeDetails()">
            Collapse panel
          </button> -->


        </div>
      </div>
    </aside>
  }


</div>



